import { NJButton, NJCheckbox, NJText } from '@engie-group/fluid-design-system-react';
import { UMR } from '../../urbanmap/_components';
import { buildingsByIds, labelOf } from './engine';
import { changeSelection, composition } from './composition';
import { ContextSets } from './ContextSets';
import type { Family, Plan, Project } from './types';
import { fmt } from './ui';

export function BuildingsSection(p: {
  project: Project; plan: Plan; total: number; canWrite: boolean;
  onUpdate: (changes: Partial<Plan>) => void; onOpenSet: (family: Family, id: string) => void; onSST: () => void;
}) {
  const ids = p.plan.buildingIds ?? [];
  const { added, excluded } = composition(p.project, p.plan);
  return <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
    <NJText as="h3" scale="md" style={{ margin: 0 }}>Bâtiments</NJText>
    <div style={{ display: 'flex', gap: 20 }}>
      <div><NJText scale="xs">Bâtiments</NJText><NJText scale="lg">{ids.length}</NJText></div>
      <div><NJText scale="xs">Consommation totale</NJText><NJText scale="lg">{fmt(p.total)} MWh/an</NJText></div>
    </div>
    <NJText scale="xs">Somme des consommations disponibles ; {ids.length - buildingsByIds(ids).filter((b) => b.heatKnown).length} consommation(s) non renseignée(s), exclue(s) du total.</NJText>
    <ContextSets {...p} families={['demande', 'importance']} />
    <NJButton label="SST / locaux techniques du projet" variant="secondary" scale="sm" onClick={p.onSST} />
    <NJText scale="xs">Sélections copiées à l’ajout, sources conservées ; déduplication automatique. Cliquez un bâtiment pour affiner.</NJText>
    <fieldset disabled={!p.canWrite} style={{ border: 0, margin: 0, padding: 0 }}>
      <legend>Sélections incluses</legend>
      {p.project.selections.map((selection) => <NJCheckbox key={selection.id} label={`${selection.name} · ${selection.buildingIds.length}`}
        isChecked={p.plan.selectionIds?.includes(selection.id) ?? false}
        onChange={(_, checked) => p.onUpdate(changeSelection(p.project, p.plan, selection.id, !!checked))} />)}
    </fieldset>
    <NJText scale="xs">{added.length} ajouts individuels · {excluded.length} retraits · {p.plan.buildingsConfirmed ? 'Confirmés' : 'À confirmer'}</NJText>
    <div style={{ maxHeight: 260, overflowY: 'auto' }}>
      {ids.map((id) => <div key={id} style={{ display: 'flex', alignItems: 'center', borderBottom: `1px solid ${UMR.border}` }}>
        <NJText scale="xs" style={{ flex: 1 }}>{labelOf(id)}</NJText>
        {p.canWrite && <NJButton label="Retirer" variant="secondary" emphasis="minimal" scale="sm"
          onClick={() => p.onUpdate({ buildingIds: ids.filter((item) => item !== id) })} />}
      </div>)}
      {!ids.length && <NJText scale="sm">Aucun bâtiment : choisissez une sélection ou utilisez la carte.</NJText>}
    </div>
  </div>;
}
